import config from "../helper/config";
import sessionManager from "../utils/simpleSessionManager";

const MAX_EVENTS = 20;
const ringBuffer = [];

/**
 * Called from posthog.js's before_send hook (non-production only). Records a copy for
 * inspection; must never alter the CaptureResult passed to before_send.
 */
export function recordEvent(distinctId, event, properties) {
  ringBuffer.push({ distinctId, event, properties, at: Date.now() });
  if (ringBuffer.length > MAX_EVENTS) ringBuffer.shift();
}

/**
 * Exposes window.__phDebug so QA can run the two-tab gate (task #1749) by reading
 * console values in each tab instead of digging through the network panel. No-op in
 * production - never call this from posthog.js when config.Environment === "production".
 */
export function initDebugHarness(posthog) {
  if (config.Environment === "production") return;

  window.__phDebug = {
    distinctId: () => posthog.get_distinct_id(),
    sessionType: () => sessionManager.getSessionType(),
    isImpersonating: () => posthog.get_property("is_impersonated") === true,
    recentEvents: () => ringBuffer.slice(),
  };
}
